import { render, staticRenderFns } from "./ModalAnswers.vue?vue&type=template&id=e2829ec4"
import script from "./ModalAnswers.vue?vue&type=script&lang=js"
export * from "./ModalAnswers.vue?vue&type=script&lang=js"
import style0 from "./ModalAnswers.vue?vue&type=style&index=0&id=e2829ec4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports